import { Box, Container, Typography, } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useCallback, useState } from 'react'
import DataGridV2 from '../../../../components/DataGridV2';
import { apps, LOCAL_STORAGE_GRID_KEYS } from '../../../../_constants';
import { useSelector } from 'react-redux';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import { INITIAL_ROW_SELECTION_MODEL } from '../../../../components/DataGridV2/constants';
import { formatDate, getLocalStorageItem, setLocalStorageItem } from '../../../../_helpers';
import { useTranslation } from 'react-i18next';
import { Build } from '@mui/icons-material';
import { getSecondSignatureRepairRequestWorkOrderColumns } from './secondSignatureRepairRequestWorkOrderUtils';

const SecondSignatureRepairRequestWorkOrders = ({ data }) => {
    const classes = useStyles();
    const app = useSelector((state) => state.app);
    const apiRef = useGridApiRef();
    const { i18n, t } = useTranslation();
    const keyPrefix = app === apps.aftercare ? "AFTERCARE" :  "GENERAL";
    const [rowSelectionModel, setRowSelectionModel] = useState(INITIAL_ROW_SELECTION_MODEL);
    const [paginationModel, setPaginationModel] = useState(() => getLocalStorageItem(
        LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION[keyPrefix], undefined
    ))
    const processedData = data.map((row, index) => ({
        id: row.resolverId || index,
        ...row
    }));

     const columns = getSecondSignatureRepairRequestWorkOrderColumns({t,keyPrefix,i18n,apiRef})   

     const getSecondSignatureRepairRequestWorkOrdersForPrintAndDownload = ({ isAllSelected = true, idsToExport = [] }) => {
       const userSelectedRows = isAllSelected ? data : idsToExport.map(id => data?.find(item => item?.resolverId === id));
       const results = userSelectedRows?.map(item => {
         const result = {};
         Object.keys(item).forEach(key => {
           let value = item[key];
           const isDateField = columns.some(x => x.field === key && x.type === 'date');
   
           if (isDateField) {
             value = item[key] ? formatDate(new Date(item[key])) : "";
           }
           else if (key === "status") {
             value = value !== undefined ? t(`resolver.status.${value}`) : "";
           }
           result[key] = value;
         });
   
         return result;
       });
   
       return results;
     };
    const onPaginationModelChange = useCallback((newPaginationModel) => {
        setPaginationModel(newPaginationModel)
        setLocalStorageItem(
            LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_PAGINATION[keyPrefix],
            newPaginationModel
        );
    }, [keyPrefix])



    return (
        <Container maxWidth={false} className={classes.mainContainer}>
            <Box>
                <Typography component="h2" variant="h6" mb={1} className="header">
                     <Build color="primary" /> &nbsp; {t("general.workOrders")}
                </Typography>
            </Box>
            <DataGridV2
                localSearchIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_SEARCH_TEXT[keyPrefix]}
                localColumnFilterIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_FILTER}
                localColumnSortIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_SORT[keyPrefix]}
                localColumnOrderIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_ORDER[keyPrefix]}
                localColumnWidthIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_WIDTH[keyPrefix]}
                localColumnVisibilityIdentifier={LOCAL_STORAGE_GRID_KEYS.SECOND_SIGNATURE_REPAIR_REQUEST_WORK_ORDERS_COLUMN_VISIBILITY[keyPrefix]}
                apiRef={apiRef}
                rows={processedData}
                columns={columns}
                pagination
                filterMode="client"
                {...(!!paginationModel && { paginationModel })}
                onPaginationModelChange={onPaginationModelChange}
                rowSelectionModel={rowSelectionModel}
                onRowSelectionModelChange={(newRowSelectionModel) => {
                    setRowSelectionModel(newRowSelectionModel);
                }}
                forceMobileView={true}
                toolbarProps={{
                    selectedRows: rowSelectionModel,
                    getData:getSecondSignatureRepairRequestWorkOrdersForPrintAndDownload,
                }}
            />
        </Container>

    )
}
const useStyles = makeStyles((theme) => ({
    mainContainer: {
        padding: 0,
    },
}));
export default SecondSignatureRepairRequestWorkOrders
